import React from 'react';
import { Checkbox } from 'semantic-ui-react';

export interface CmCheckboxProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: React.ReactNode;
  disabled?: boolean;
  testId?: string;
  ariaLabel?: string;
}

export function CmCheckbox({
  checked,
  onChange,
  label,
  disabled = false,
  testId,
  ariaLabel,
}: CmCheckboxProps): React.ReactElement {
  return (
    <Checkbox
      checked={checked}
      onChange={(_, data) => onChange(Boolean(data.checked))}
      label={label}
      disabled={disabled}
      data-testid={testId}
      aria-label={ariaLabel}
    />
  );
}

export default CmCheckbox;
